import 'client-only';

import { clientAnalyticsProviders } from '../analytics/client-analytics-providers';

export function captureEvent(
  eventName: string,
  properties?: Record<string, unknown>
): void {
  clientAnalyticsProviders.forEach(provider =>
    provider.captureEvent(eventName, properties)
  );
}
